/**
 * @generated SignedSource<<fb76f5f57fd0e05966be278e30f7679c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontHead_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontSocial_user">;
  readonly " $fragmentType": "StorefrontHead_user";
};
export type StorefrontHead_user$key = {
  readonly " $data"?: StorefrontHead_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontHead_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHead_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontSocial_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "be37b972407a12aa7fb1298dc9b08296";

export default node;
